var _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgJeuConsole = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.42 51.92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.09 11.44 18.73 .99 36.54 14.04 26.81 33.48 5.6 33.33 1.09 11.44",
    fill: "#3cf",
    opacity: 0.2,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.31,18.77H14.97v11.49h-1.28v-3.49h-4.07v23.72h13.64v-7.07h26.72l6.55,6.55,1.18-1.18-5.37-5.37h7.97v-24.65ZM21.58,43.42v5.4h-.72v-20.37h.72v14.97ZM18.81,48.81h-5.12v-16.88h5.12v16.88ZM12.02,48.81h-.72v-20.37h.72v20.37ZM58.64,41.74H23.25v-14.97h-4.07v3.49h-2.53v-9.81h41.99v21.29Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,50.74h-14.14v-24.22h4.57v3.49h.78v-11.48h45.84v25.14h-7.61l5.12,5.12-1.54,1.54-6.66-6.66h-26.37v7.07ZM9.87,50.24h13.14v-7.07h27.08l6.45,6.45.83-.83-5.62-5.62h8.32v-24.14H15.22v11.48h-1.78v-3.49h-3.57v23.22ZM21.83,49.06h-1.22v-20.87h1.22v20.87ZM21.1,48.56h.22v-19.87h-.22v19.87ZM19.06,49.06h-5.62v-17.38h5.62v17.38ZM13.94,48.56h4.62v-16.38h-4.62v16.38ZM12.26,49.06h-1.22v-20.87h1.22v20.87ZM11.54,48.56h.22v-19.87h-.22v19.87ZM58.89,41.99H23v-14.97h-3.57v3.49h-3.03v-10.31h42.49v21.79ZM23.5,41.49h34.88v-20.79H16.9v9.31h2.03v-3.49h4.57v14.97Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.84,
    y: 30.08,
    width: 12.99,
    height: 1.68,
    transform: "translate(-9.43 27.44) rotate(-30.67)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.08,35.3l-1.11-1.87,11.6-6.88,1.11,1.87-11.6,6.88ZM39.66,33.6l.6,1.01,10.74-6.37-.6-1.01-10.74,6.37Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.07,
    y: 26.38,
    width: 6.83,
    height: 1.68,
    transform: "translate(-7.94 25.49) rotate(-30.68)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.89,30.02l-1.11-1.87,6.31-3.74,1.11,1.87-6.31,3.74ZM39.46,28.33l.6,1.01,5.45-3.23-.6-1.01-5.45,3.23Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.83,
    y: 34.41,
    width: 6.83,
    height: 1.68,
    transform: "translate(-11.37 29.05) rotate(-30.69)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.65,38.05l-1.11-1.87,6.31-3.74,1.11,1.87-6.31,3.74ZM44.22,36.36l.6,1.01,5.45-3.23-.6-1.01-5.45,3.23Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "15.41 39.56 15.41 43.42 15.41 47.89 17.09 47.89 17.09 43.42 17.09 41.74 17.09 39.56 16.65 39.56 15.41 39.56",
    fill: "#1d1e1c",
    strokeWidth: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJeuConsole);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Jeu Console.dd16c14f6720613abb04288f2956aeda.svg";